<script>
    import { onMount, onDestroy } from 'svelte';
    import { scale } from 'svelte/transition';
    import { quintOut } from 'svelte/easing';

    import Searchbox from "../components/searchbox.svelte";
    import AutoComplete from "simple-svelte-autocomplete"

    import { user } from '../store/authStore';
    import { lists } from '../store/lists';
    import { items } from '../store/items';
    import { categories } from "../store/categories";
    import { recurring } from "../store/recurring";
    import { recentIDB } from '../store/recent';
    import { page, modal } from '../store/nav';
    import { createId, nextDate } from '../js/helper';

    import { productsIDB } from "../store/products";

    export let list_uid;
    export let redirect;

    let recentEntries = [];
    let products = [];
    let validOptions = [];

    let selectedOption;
    let text;

    console.log(`redirect`, redirect, redirect != "undefined", !! redirect);

    const backUrl = list_uid == `recurring` ? `/lists/recurring` : `/lists/items?list_uid=${list_uid}`;

    onMount(async () => {
		await recentIDB.init('items_all');
        if ( $recentIDB ) {
            recentEntries = $recentIDB.entries;
            console.group(`INFO: /select-item.onMount`);console.log(`recentEntries`);console.log(recentEntries);console.groupEnd()
        }
       
        await productsIDB.init(`all`);
        products = $productsIDB.sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0));
        console.log(`validOptions`);console.log(validOptions);
        console.group(`INFO: /select-item.onMount`);console.log(`products`);console.log(products);console.groupEnd()
    });

    const unsubscribe = recentIDB.subscribe( r => {
        console.group(`INFO: /select-item-generic.recentEntries`);console.log(r);console.groupEnd();
    });

    onDestroy(()=>{
        unsubscribe();
    });

    const createNewProduct = (name) => {
        modal.open(`/new-item?list_uid=${list_uid}&name=${name}&redirect=${redirect}&anchor=bottom`);
    };

    const setItem = i => {
        console.group(`INFO: /select-item-generic. setItem`);console.log(i);console.groupEnd();
        if ( list_uid == "recurring" ){
            const item = {
                "uid":createId.uuid(),
                "name":i.name,
                "productUid":`${i.uid}`,
                "category":i.category,
                "storeUid":"",
                "storeName":"",
                "frequency":"weekly",
                "qty":1,
                "unit":"lbs",
                "next":nextDate(7),
                "options":$categories[i.category].options,
                "cut":"",
                "details":""
            };
            recurring.add(item);

            if ( !! redirect && redirect != "undefined"  ) {
                page.route(`${redirect}?list_uid=${list_uid}&item_uid=${item.uid}`)
            } else {
                page.route('/lists/recurring');
            }
            
        } else {
            const item = {
                "uid":createId.uuid(),
                "listUid":list_uid,
                "productUid":`${i.uid}`,
                "name":i.name,
                "category":i.category,
                "collected":false,
                "status":"it_none",
                "qty":1,
                "unit":"lbs",
                "recurring": false,
                "next":nextDate(7),
                "options":$categories[i.category].options,
                "cut":"",
                "details":""
            };
            recentIDB.add( `items_${item.category}`, {uid:i.uid,name:item.name,category:item.category},  {relatedStore: `items_all`} );
            items.add(item);
            lists.editSingleField(list_uid, 'lastUpdated', Date.now());
            
            if ( !! redirect && redirect != "undefined"  ) {
                page.route(`${redirect}?list_uid=${list_uid}`)
            } else {
                page.route('/lists/items?list_uid='+list_uid);
            }
        }
    };
</script>

<section id="list" in:scale="{{delay: 250, duration: 300, easing: quintOut }}" out:scale="{{delay: 250, duration: 300, easing: quintOut }}" class="z-0 fixed top-0 left-0 h-screen w-screen font-primaryBold text-primary flex flex-col space-y-8 pt-5 pl-7 bg-secondary" >
    <section id="top-bar" class="flex pr-7 justify-between items-stretch ">
        <div id="back-btn" class="" on:click={()=>page.back(backUrl)} >
            <svg viewBox="0 0 18 18" class="fill-primary mt-3.5 h-5" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M11.7803 2.46967C12.0732 2.76256 12.0732 3.23744 11.7803 3.53033L6.31066 9L11.7803 14.4697C12.0732 14.7626 12.0732 15.2374 11.7803 15.5303C11.4874 15.8232 11.0126 15.8232 10.7197 15.5303L4.71967 9.53033C4.42678 9.23744 4.42678 8.76256 4.71967 8.46967L10.7197 2.46967C11.0126 2.17678 11.4874 2.17678 11.7803 2.46967Z"/>
            </svg>
        </div>
        <div id="title" class="place-self-center font-primaryXBold text-lg">Select Item</div>
        <div id="title-menu"class="w-10 h-12 place-self-center" >
            <svg class="fill-primary mt-3.5 m-auto" width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.5 3C10.5 3.82843 9.82843 4.5 9 4.5C8.17157 4.5 7.5 3.82843 7.5 3C7.5 2.17157 8.17157 1.5 9 1.5C9.82843 1.5 10.5 2.17157 10.5 3Z"/>
                <path d="M10.5 9C10.5 9.82843 9.82843 10.5 9 10.5C8.17157 10.5 7.5 9.82843 7.5 9C7.5 8.17157 8.17157 7.5 9 7.5C9.82843 7.5 10.5 8.17157 10.5 9Z"/>
                <path d="M9 16.5C9.82843 16.5 10.5 15.8284 10.5 15C10.5 14.1716 9.82843 13.5 9 13.5C8.17157 13.5 7.5 14.1716 7.5 15C7.5 15.8284 8.17157 16.5 9 16.5Z"/>
            </svg>
        </div>
    </section>

    <section id="search" class="pr-7 flex space-x-0"> 
        <!--section class="form-input-text relative h-16 text-primary">
            <span class="absolute inset-y-0 left-0 h-16 z-10 flex items-center pl-6">
                <button type="submit" class="p-1 focus:outline-none focus:shadow-outline">
                    <svg width="20" height="21" viewBox="0 0 20 21" class="fill-primary" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M15.274 16.1191C13.8374 17.2947 12.0011 18 10.0001 18C5.39771 18 1.66675 14.269 1.66675 9.66666C1.66675 5.06429 5.39771 1.33333 10.0001 1.33333C14.6025 1.33333 18.3334 5.06429 18.3334 9.66666C18.3334 11.6677 17.6281 13.5041 16.4525 14.9406L18.9227 17.4108C19.2481 17.7362 19.2481 18.2639 18.9227 18.5893C18.5972 18.9147 18.0696 18.9147 17.7442 18.5893L15.274 16.1191ZM16.6667 9.66666C16.6667 13.3486 13.682 16.3333 10.0001 16.3333C6.31818 16.3333 3.33341 13.3486 3.33341 9.66666C3.33341 5.98476 6.31818 2.99999 10.0001 2.99999C13.682 2.99999 16.6667 5.98476 16.6667 9.66666Z"/>
                    </svg>
                </button>
            </span>
            <input type="text" style="width: 100%;" class="text-sm z-0 h-16 pl-14 shadow-xs placeholder-primary rounded-3xl focus:caret-primary border-primary border focus:ring-1 focus:ring-primary focus:outline-none focus:placeholder-shade" placeholder="Search" autocomplete="off" >
        </section-->
        <!--Searchbox bind:selectedOption on:optionSelected={setItemFromOption} options={products} /-->
        <!--AutoComplete 
            placeholder="Search product"
            className="grow w-full" 
            inputClassName="p-2.5 m-0 border w-full grow" 
            hideArrow={true} 
            items="{products}" 
            bind:selectedItem={selectedOption} 
            labelFieldName="name" 
            valueFieldName="uid" 
            bind:text
            create={true}
            createText={"Item doesn't exist, create one?"}
            onCreate={createNewProduct} 
        /-->

        <AutoComplete placeholder="Search product"
            className="grow w-full" 
            inputClassName="p-2.5 m-0 border w-full grow" 
            hideArrow={true} 
            items="{products}" 
            bind:selectedItem={selectedOption} 
            labelFieldName="name" 
            valueFieldName="uid" 
            bind:text
            create={true}
            createText={"Item doesn't exist, create one?"}
            onCreate={createNewProduct}>

            <div slot="item" class="flex space-x-2" let:item={item} let:label={label}>
                <div class="bg-primary rounded-2xl w-7 h-7" >
                    <img class="m-auto w-5 mt-1" src="/img/icon/food/{item.category}.png" alt=""/>
                </div>
                <span class="flex justify-center items-center">{@html label}</span>
            </div>
        
            <div slot="create" let:createText={createText}>
               <strong>{text}</strong> doesn't exist, create?
            </div>
        
        </AutoComplete>

        <input type="submit" on:click|preventDefault={()=>setItem(selectedOption)} class="bg-primary text-secondary outline-1 p-0 m-0 text-center align-middle w-20 h-10 shrink-0" value="Select">
    </section>

    <section class="flex flex-col">
        <span class="pr-7 font-primaryBold text-2xl">Recent</span>
        <section class="flex space-x-5 h-24">
            <section class="flex flex-col w-14">
                <div class=" flex flex-col grow">
                    <div id="add-list" class="bg-primary w-8 h-8 place-self-center mt-4  rounded-full text-center"  on:click|stopPropagation={() => modal.open(`/new-item?list_uid=${list_uid}&anchor=bottom`)}>
                        <svg class="m-auto mt-2.5 w-3 fill-secondary" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
                            <path d="M6.75 0.75C6.75 0.335786 6.41421 0 6 0C5.58579 0 5.25 0.335786 5.25 0.75V5.24993L0.75 5.24993C0.335786 5.24993 0 5.58572 0 5.99993C0 6.41414 0.335786 6.74993 0.75 6.74993L5.25 6.74993V11.25C5.25 11.6642 5.58579 12 6 12C6.41421 12 6.75 11.6642 6.75 11.25V6.74993L11.25 6.74993C11.6642 6.74993 12 6.41415 12 5.99993C12 5.58572 11.6642 5.24993 11.25 5.24993L6.75 5.24993V0.75Z"/>
                        </svg>
                    </div>
                </div>
                <span class="text-xs w-14 text-center m-auto">Create new item</span>
            </section>
            <section id="recent" class="flex space-x-5 overflow-x-auto overflow-y-hidden no-scrollbar pt-4">
                {#each recentEntries as recent}
                    <section class="flex w-14 flex-col shrink-0" on:click={()=>setItem(recent)}>
                        <div class="bg-primary rounded-2xl w-14 h-14"><img class="m-auto w-9 mt-2.5" src="/img/icon/food/{recent.category}.png" alt=""/></div>
                        <div class=" w-14 h-4.5 text-xs text-center place-self-center capitalize text-ellipsis overflow-hidden">{recent.name}</div>
                    </section>
                {/each}
            </section>
        </section>
    </section>  

    <section id="all" class="flex flex-col pr-7 space-y-5 overflow-auto grow">
        <section class="">
            <span class=" font-primaryBold text-2xl">Categories</span>
        </section>
        <section id="all-list" class="flex space-y-5 flex-col grow overflow-scroll no-scrollbar">
            {#each Object.keys($categories) as category}
                <section class="flex space-x-5 ml-7" on:click|stopPropagation={()=> page.route(`/lists/items/item-category?list_uid=${list_uid}&category_uid=${category}&redirect=${redirect}`)} >
                    <!--input type="radio" name="" id=""/-->
                    <div class="bg-primary rounded-2xl w-12 h-12" >
                        <img class="m-auto w-8 mt-2" src="/img/icon/food/{category}.png" alt=""/>
                    </div>
                    <div class="place-self-center capitalize">
                        {category}
                    </div>
                </section>
            {/each}
        </section>
    </section>

</section>       

<style lang="postcss">
input {
    height: 34px !important;
}
</style>
